import { InputHTMLAttributes } from 'react';

import { FieldID } from '../types';

export type StaticInputProps = {
  dataTest: string;
  type?: InputHTMLAttributes<HTMLInputElement>['type'];
  autoComplete?: InputHTMLAttributes<HTMLInputElement>['autoComplete'];
};

const staticInputFieldProps: {
  [key in FieldID]?: StaticInputProps;
} = {
  address_lines: {
    autoComplete: 'address-line1',
    dataTest: 'address_lines',
  },
  city: {
    autoComplete: 'address-level2',
    dataTest: 'city',
  },
  apartment_number: {
    dataTest: 'apartment_number',
    // somehow this field is being autofilled without the autocomplete attribute
    // so we have to fool it by using a non semantic value
    autoComplete: 'apartment-number',
  },
  street_number: {
    dataTest: 'street_number',
  },
  street: {
    dataTest: 'street',
  },
  postal_code: {
    autoComplete: 'postal-code',
    dataTest: 'postal_code',
  },
  email: {
    autoComplete: 'email',
    type: 'email',
    dataTest: 'email',
  },
  name: {
    autoComplete: 'name',
    dataTest: 'name',
  },
  phone_number: {
    autoComplete: 'tel',
    type: 'tel',
    dataTest: 'phone_number',
  },
  first_name: {
    autoComplete: 'given-name',
    dataTest: 'first_name',
  },
  last_name: {
    autoComplete: 'family-name',
    dataTest: 'last_name',
  },
  region: {
    autoComplete: 'address-level1',
    dataTest: 'region',
  },
  subregion: {
    autoComplete: 'address-level3',
    dataTest: 'subregion',
  },
  company_name: {
    dataTest: 'company_name',
  },
  vat: {
    dataTest: 'vat',
  },
  customs_number: {
    dataTest: 'customs_number',
  },
};

export const getStaticInputProps = (name: FieldID) => {
  return staticInputFieldProps[name];
};
